<!-- Кнопка открывает разрешённые счётчики компаний; выбор меняет company context. -->
<template>
  <div v-if="companies.length || modalOpen" class="notification-other-companies">
    <base-button
      v-if="companies.length"
      ref="trigger"
      icon="bell"
      aria-haspopup="dialog"
      :aria-expanded="modalOpen"
      @click="modalOpen = true"
    >
      Уведомления других компаний
      <BaseBadge>{{ counterStore.otherUnreadCount }}</BaseBadge>
    </base-button>
    <BaseModal
      :visible="modalOpen"
      title="Уведомления других компаний"
      size="md"
      @close="closeModal"
    >
      <ul v-if="companies.length" class="notification-other-companies__list">
      <li v-for="company in companies" :key="company.company_id">
        <base-button
          variant="ghost"
          class="notification-other-companies__button"
          :disabled="userStore.isSwitchingCompany"
          :aria-label="`${company.name}: ${company.unread_count} непрочитанных. Перейти к уведомлениям компании`"
          @click="openCompany(company.company_id)"
        >
          <span class="notification-other-companies__name">{{ company.name }}</span>
          <BaseBadge>{{ company.unread_count }}</BaseBadge>
        </base-button>
      </li>
      </ul>
      <BaseEmptyState v-else icon="bell" title="Непрочитанных уведомлений нет" />
    </BaseModal>
  </div>
</template>

<script>
import { useNotificationCounterStore } from "@/stores/notificationCounterStore";
import { useUserDataStore } from "@/stores/userDataStore";

export default {
  name: "NotificationOtherCompanies",
  data() {
    return { modalOpen: false };
  },
  computed: {
    counterStore() {
      return useNotificationCounterStore();
    },
    companies() {
      return this.counterStore.otherCompanyNotifications;
    },
    userStore() {
      return useUserDataStore();
    },
  },
  methods: {
    closeModal() {
      this.modalOpen = false;
      this.$nextTick(() => this.$refs.trigger?.$el.focus());
    },
    async openCompany(companyId) {
      if (await this.userStore.switchCompany(companyId)) {
        // Полная загрузка освобождает company-scoped stores всех разделов приложения.
        window.location.assign(this.$router.resolve({ name: "Notifications" }).href);
      }
    },
  },
};
</script>

<style scoped>
.notification-other-companies {
  margin-bottom: 12px;
}
.notification-other-companies__list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notification-other-companies__list .notification-other-companies__button {
  width: 100%;
  min-height: 44px;
  text-align: left;
  justify-content: space-between;
}
.notification-other-companies__name {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
